module.exports = __webpack_public_path__ + "img/bell.db18d848.svg";